// TODO: remove this one and replace it with isNullOrEmpty
export default value => value === null || value === undefined;
